import {get as _get, isEmpty as _isEmpty} from 'lodash';
import PropTypes from 'prop-types';

import {WIZARD_TABS_VALIDATION_TEXT} from '@constants/messages';
import {EVENT_CONTENT_BOOKED_BY_CLIENT, EVENT_CONTENT_OFFERED_BY_CLIENT} from '@constants/variables';
import {showEmailPreview} from '@utils/forms';

import NotificationForm from './NotificationForm';

export default class EventGroupNotificationForm extends NotificationForm {
    static propTypes = {
        ...super.propTypes,
        eventDescription: PropTypes.string,
    };

    componentDidMount() {
        super.componentDidMount();

        this.setField('description', {
            defaultValue: this.props.eventDescription,
        });
    }

    setRecipientType = () => {
        let preselectTypes = [EVENT_CONTENT_BOOKED_BY_CLIENT, EVENT_CONTENT_OFFERED_BY_CLIENT];

        this.setField('recipient_type', {
            defaultValue: preselectTypes,
        });
    };

    prepareDataForSubmit = (formData) => {
        let data = super.prepareDataForSubmit(formData);

        data.events = this.props.formParams.optionsVariables.eventsIds;

        return data;
    };

    onFormSubmit(formValues) {
        if (!_isEmpty(this.props.stepsMethods) && !this.props.stepsMethods.validateForms()) {
            this.setFormMessage(WIZARD_TABS_VALIDATION_TEXT(
                _get(this.props, 'Model.label', _get(this.props, 'Model.formName', ''))
                    .toLocaleLowerCase()
            ));
        }

        this.setState(() => ({
            defaultForm_errorShowed: false,
        }));

        const data = this.prepareDataForSubmit(formValues);

        this.props.MessageBox.removeMessage(this.state.defaultForm_formValidationMessageBoxName);

        showEmailPreview(this.props, data);
    }
}
